require("fg-frontend/third/highslide/highslide-full");

var hs = window.hs;

hs.graphicsDir = "/img/highslide/";
hs.transitions = ["expand", "crossfade"];
hs.objectLoadTime = "before"; // Load iframes 'before' or 'after' expansion.
hs.outlineType = null;
hs.align = "center";
hs.dimmingOpacity = 0.96;
hs.useBox = true;
hs.width = 20000;
hs.height = 5000;
hs.minHeight = 500;
hs.targetY = "page-header 160px";
hs.zIndexCounter = 1011;

if (document.getElementsByTagName("h1").length > 0) {
	hs.headingText =
		'<h2 class="highslide-title text-center">' +
		document.getElementsByTagName("h1")[0].innerHTML +
		"</h2> " +
		'<a title="Zavřít" href="javascript:" onclick="return hs.close(this)"><span class="close"><span class="glyphicon glyphicon-close no-margin"></span></span></a>';
}
hs.headingOverlay.fade = 0;

hs.addSlideshow({
	/* thumbstrip: {
		position:   'rightpanel',
		mode:       'vertical',
		relativeTo: 'expander',
		width:      '250px',
	}, */
	repeat: true,
});

hs.cacheAjax = false;
hs.preserveContent = false;

// credits off
hs.showCredits = false;
hs.creditsHref = "";
hs.lang.creditsText = "";
hs.lang.creditsTitle = "";
hs.captionEval = "this.a.title";

/* if (hs.registerOverlay) {
	hs.registerOverlay({
		fade: 2,
		hideOnMouseOut: false,
		html: '<a title="Zavřít" href="javascript:" onclick="return hs.close(this)"><span class="close"><span class="glyphicon glyphicon-close no-margin"></span></span></a>',
		useOnHtml: true,
		position: "top right",
	});
} */

hs.Expander.prototype.onBeforeExpand = function (sender) {
	//jen pro obrazky
	if (sender.a.className.indexOf("hs-htmlExpand") < 0) {
		// dynamicka navigace mezi fotkami

		var arrowLeft = document.createElement("div");
		var arrowRight = document.createElement("div");

		if (sender.getAdjacentAnchor(-1)) {
			var _codeL =
				'<a href="javascript:" onclick="return hs.previous(this)" title="Předchozí" class="highslide-previous"><span class="btn-prev">';
			if (document.body.classList.contains("styles-aeu"))
				_codeL +=
					'<svg class="svg-icon"><use xlink:href="/img/img-aeu/ico-arrow-left.svg#icon"></use></svg>';
			_codeL += "</span></a>";
			arrowLeft.innerHTML = _codeL;
			arrowLeft.className = "controlbar-arrows";
		}
		if (sender.getAdjacentAnchor(1)) {
			var _codeR =
				'<a href="javascript:" onclick="return hs.next(this)" title="Následující" class="highslide-next"><span class="btn-next">';
			if (document.body.classList.contains("styles-aeu"))
				_codeR +=
					'<svg class="svg-icon"><use xlink:href="/img/img-aeu/ico-arrow-right.svg#icon"></use></svg>';
			_codeR += "</span></a>";
			arrowRight.innerHTML = _codeR;
			arrowRight.className = "controlbar-arrows";
		}
		if (arrowLeft.innerHTML != "") {
			sender.createOverlay({
				overlayId: arrowLeft,
				position: "middle left",
				offsetX: 40,
				hideOnMouseOut: false,
				opacity: 1,
				width: "auto",
				fade: 2,
			});
		}
		if (arrowRight.innerHTML != "") {
			sender.createOverlay({
				overlayId: arrowRight,
				position: "middle right",
				offsetX: -40,
				hideOnMouseOut: false,
				opacity: 1,
				width: "auto",
				fade: 2,
			});
		}
	}
};

hs.Expander.prototype.onAfterExpand = function (sender) {
	document.body.style.overflow = "hidden";
	/* var offset = $(".highslide-wrapper")[0].offsetTop;
	$(window).scrollTop(offset); */
};

hs.Expander.prototype.onBeforeClose = function (sender) {
	document.body.style.overflow = "initial";
};



// WEBPACK FOOTER //
// ./config/module-publish/resources/js/web/highslide-settings.js